import { LOCATION_CHANGE } from 'react-router-redux';

import { readableUrl } from '@wix/communities-blog-client-common';

const initialState = {
  key: undefined,
  items: [],
};

const find = (items, key) => items.findIndex((item) => item.key === key);

const withReadablePath = (location) => location && { ...location, pathname: readableUrl(location.pathname) };

const locationChange = (state, { payload: { action, ...location } }) => {
  const currentIdx = find(state.items, state.key);
  const locationIdx = find(state.items, location.key);
  switch (action) {
    case 'POP':
      if (locationIdx > -1) {
        return {
          ...state,
          items: state.items.slice(0, locationIdx + 1),
          key: location.key,
        };
      }
      return { key: location.key, items: [...state.items, location] };
    case 'PUSH':
      return { key: location.key, items: [...state.items.slice(0, currentIdx + 1), withReadablePath(location)] };
    case 'REPLACE':
      return { key: location.key, items: [...state.items.slice(0, locationIdx), withReadablePath(location)] };
    default:
      return state;
  }
};

const locationHistory = (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      return locationChange(state, action);
    default:
      return state;
  }
};

export default locationHistory;
